import { normalizeString } from "@rebuild/shared";
import { IXactimateToolRowData } from "../shared/common/Azure";

/**
 * Finds an existing mapping in `rows` that conflicts with `candidate` —
 * same `selectedLineItemId` and a normalized-equal `acceptedLineString` —
 * while excluding `candidate.id` itself. Returns the conflicting row or null.
 */
export const findDuplicateMapping = (
  rows: IXactimateToolRowData[],
  candidate: IXactimateToolRowData,
): IXactimateToolRowData | null => {
  if (!candidate.selectedLineItemId || !candidate.acceptedLineString) return null;
  const normalizedCandidate = normalizeString(candidate.acceptedLineString);
  return (
    rows.find(
      (r) =>
        r.id !== candidate.id &&
        r.selectedLineItemId === candidate.selectedLineItemId &&
        !!r.acceptedLineString &&
        normalizeString(r.acceptedLineString) === normalizedCandidate,
    ) ?? null
  );
};
